<template>
    <div class="filter">
        <div class="row">
            <div class="col-md-3 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label><abbr title="Obligatorio">*</abbr>Destino: </label>
                    <input type="text" v-model="r.name"  class="form-control required">
                </div>
            </div>
        </div>
        <div class="input-group-btn">
            <button class="btn btn-success" v-on:click="modifyCurrency()">Aceptar</button>
        </div>
    </div>
</template>



<script>
    export default {
        props: ['r', 'history'],
        methods: {
            modifyCurrency() {
                if (this.r.id != null){
                    this.$http.put('/admin/destinations/'+this.r.id, {destination: this.r}).then(response => {
                        Turbolinks.visit('/admin/destinations/' + response.body.id)
                    }, response=> {
                        console.log(response);
                        }
                    )
                }

            }
        },
        data: function () {
            return {currency: 'r' }
        }
    }
</script>